import { BookingState } from './index';
import { createSelector } from '@reduxjs/toolkit';
import { Device } from '../types';

export const selectBookingDevices = (state: { booking: BookingState }) => state.booking.devices;
export const selectGetBookingDevicesStatus = (state: { booking: BookingState }) => state.booking.getDevicesStatus;
export const selectGetBookingDevicesErrorInfo = (state: { booking: BookingState }) => state.booking.getDevicesError;
export const selectBookingDevicesLocations = (state: { booking: BookingState }) => state.booking.locations;
export const selectGetBookingDevicesLocationsStatus = (state: { booking: BookingState }) =>
    state.booking.getLocationsStatus;
export const selectGetBookingDevicesLocationsErrorInfo = (state: { booking: BookingState }) =>
    state.booking.getLocationsError;
export const selectFullDeviceInfo = (state: { booking: BookingState }) => state.booking.fullDeviceInfo;
export const selectGetFullDeviceInfoStatus = (state: { booking: BookingState }) =>
    state.booking.getFullDeviceInfoStatus;
export const selectGetFullDeviceInfoErrorInfo = (state: { booking: BookingState }) =>
    state.booking.getFullDeviceInfoError;
export const selectBookings = (state: { booking: BookingState }) => state.booking.bookings;
export const selectLocalBookings = (state: { booking: BookingState }) => state.booking.bookingsLocal;
export const selectSelectedBookings = (state: { booking: BookingState }) => state.booking?.bookingsSelected ?? {};
export const selectLocalBookingsForDevice = (state: { booking: BookingState }, deviceId?: Device['pk']) =>
    deviceId ? state.booking.bookingsLocal[deviceId] : [];

export const selectAllBookings = createSelector(
    [selectBookings, selectLocalBookingsForDevice],
    (bookings, bookingsLocal) => {
        return [...bookings, ...(bookingsLocal || [])];
    },
);

export const selectGetBookingsStatus = (state: { booking: BookingState }) => state.booking.getBookingsStatus;
export const selectGetBookingsErrorInfo = (state: { booking: BookingState }) => state.booking.getBookingsError;
export const selectClosestBooking = (state: { booking: BookingState }) => state.booking.closestBooking;
export const selectCreateBookingStatus = (state: { booking: BookingState }) => state.booking.createBookingStatus;
export const selectCreateBookingErrorInfo = (state: { booking: BookingState }) => state.booking.createBookingError;
export const selectUpdateBookingStatus = (state: { booking: BookingState }) => state.booking.updateBookingStatus;
export const selectUpdateBookingErrorInfo = (state: { booking: BookingState }) => state.booking.updateBookingError;
export const selectCancelBookingStatus = (state: { booking: BookingState }) => state.booking.cancelBookingStatus;
export const selectCancelBookingErrorInfo = (state: { booking: BookingState }) => state.booking.cancelBookingError;
